<template>
  <div>
    <!-- 导航条 -->
    <top-nav></top-nav>
    <!-- 背景图 -->
    <img
      v-if="bannerList.length !== 0"
      :src="bannerList[0].CompanyName"
      class="img-fluid bg-img"
    />
    <!-- 面包屑 -->
    <div style="background-color: #f5f5f5;">
      <div class="crumbs_wrap type_area">
        <i class="iconfont iconweizhi1"></i>
        <span>您当前所在的位置：</span>
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">首页</li>
          <li class="breadcrumb-item active" aria-current="page">联系我们</li>
        </ol>
      </div>
    </div>
    <!-- 关于我们 -->
    <div class="brand_wrap">
      <div class="dynamic_wrap type_area">
        <div class="dynamic_title">
          <div>联系我们</div>
          <div>contact us</div>
        </div>

        <div class="show_wrap">
          <div class="map" id="map"></div>

          <div class="relation_wrap">
            <div class="phone_box">
              <h2>常用电话</h2>
              <ul class="phone_ui">
                <li class="phone_item">
                  <i class="iconfont icondianhua"></i>
                  <div class="title">
                    <span>服务电话</span>
                    <span>{{ footerInfo.CompanyPhone }}</span>
                  </div>
                </li>
                <li class="phone_item">
                  <i class="iconfont icondianhua"></i>
                  <div class="title">
                    <span>招商电话</span>
                    <span>{{ footerInfo.CompanyZhao }}</span>
                  </div>
                </li>
                <li class="phone_item">
                  <i class="iconfont icondianhua"></i>
                  <div class="title">
                    <span>广告合作</span>
                    <span>{{ footerInfo.CompanyHe }}</span>
                  </div>
                </li>
                <li class="phone_item" style="align-items: start;">
                  <i class="iconfont icondingwei"></i>
                  <div class="title title1">
                    <div>联系地址</div>
                    <div style="line-height: 35px;">
                      {{ footerInfo.MapProvince ? footerInfo.MapProvince : ''
                      }}{{ footerInfo.MapCity ? footerInfo.MapCity : ''
                      }}{{ footerInfo.MapDistrict ? footerInfo.MapDistrict : ''
                      }}{{ footerInfo.MapTownship ? footerInfo.MapTownship : ''
                      }}{{ footerInfo.MapStreet ? footerInfo.MapStreet : ''
                      }}{{ footerInfo.MapAddress ? footerInfo.MapAddress : '' }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div class="phone_box">
              <h2>交通指南</h2>
              <ul class="phone_ui phone_ui1">
                <li class="phone_item phone_item1">
                  <div class="title title2">
                    <div>公交站：{{ footerInfo.CompanyScale }}</div>
                    <div>地铁口：{{ footerInfo.CompanyType }}</div>
                  </div>
                </li>
              </ul>
            </div>

            <div class="wx_box">
              <h2>金多银多珠宝广场官方微信</h2>
              <div class="code_box">
                <img :src="footerInfo.CompanyFullName" />
                <div><i class="iconfont iconweixin"></i>微信</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from '../../components/top-nav'
import bottomFooter from '../../components/bottom-footer'
export default {
  components: { topNav, bottomFooter },

  data() {
    return {
      // 顶部大图数据
      bannerList: [],
      // 联系我们信息
      footerInfo: {},
      map: {}
    }
  },

  created() {
    if (
      navigator.userAgent.match(
        /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
      )
    ) {
      this.getBannerList(2)
    } else {
      this.getBannerList(1)
    }
    this.getFooterInfo()
  },

  // mounted() {
  //   function initMap() {
  //     createMap()
  //     setMapEvent()
  //     addMapControl()
  //     addMapOverlay()
  //   }

  //   function createMap() {
  //     // eslint-disable-next-line no-undef
  //     map = new BMap.Map('map')
  //     // eslint-disable-next-line no-undef
  //     map.centerAndZoom(new BMap.Point(113.687568, 34.755562), 17)
  //     // map.centerAndZoom(new BMap.Point(this.footerInfo.LocationX, this.footerInfo.LocationY), 17)
  //   }

  //   function setMapEvent() {
  //     map.enableScrollWheelZoom()
  //     map.enableKeyboard()
  //     map.enableDragging()
  //     map.enableDoubleClickZoom()
  //   }

  //   function addClickHandler(target, window) {
  //     target.addEventListener('click', function() {
  //       target.openInfoWindow(window)
  //     })
  //   }

  //   function addMapOverlay() {
  //     var markers = [
  //       {
  //         content: '郑州市管城区紫荆山路与东大街交汇处裕鸿花园A——C座裙楼',
  //         title: '金多银多珠宝广场',
  //         imageOffset: { width: 0, height: 3 },
  //         position: { lat: 34.754732, lng: 113.687999 }
  //       }
  //     ]
  //     for (var index = 0; index < markers.length; index++) {
  //       // eslint-disable-next-line no-undef
  //       var point = new BMap.Point(
  //         markers[index].position.lng,
  //         markers[index].position.lat
  //       )
  //       // eslint-disable-next-line no-undef
  //       var marker = new BMap.Marker(point, {
  //         // eslint-disable-next-line no-undef
  //         icon: new BMap.Icon(
  //           'http://api.map.baidu.com/lbsapi/createmap/images/icon.png',
  //           // eslint-disable-next-line no-undef
  //           new BMap.Size(20, 25),
  //           {
  //             // eslint-disable-next-line no-undef
  //             imageOffset: new BMap.Size(
  //               markers[index].imageOffset.width,
  //               markers[index].imageOffset.height
  //             )
  //           }
  //         )
  //       })
  //       // eslint-disable-next-line no-undef
  //       var label = new BMap.Label(markers[index].title, {
  //         // eslint-disable-next-line no-undef
  //         offset: new BMap.Size(25, 5)
  //       })
  //       var opts = {
  //         width: 200,
  //         title: markers[index].title,
  //         enableMessage: false
  //       }
  //       // eslint-disable-next-line no-undef
  //       var infoWindow = new BMap.InfoWindow(markers[index].content, opts)
  //       marker.setLabel(label)
  //       addClickHandler(marker, infoWindow)
  //       map.addOverlay(marker)
  //     }
  //   }

  //   function addMapControl() {
  //     // eslint-disable-next-line no-undef
  //     var scaleControl = new BMap.ScaleControl({
  //       // eslint-disable-next-line no-undef
  //       anchor: BMAP_ANCHOR_BOTTOM_LEFT
  //     })
  //     // eslint-disable-next-line no-undef
  //     scaleControl.setUnit(BMAP_UNIT_IMPERIAL)
  //     map.addControl(scaleControl)
  //     // eslint-disable-next-line no-undef
  //     var overviewControl = new BMap.OverviewMapControl({
  //       // eslint-disable-next-line no-undef
  //       anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
  //       isOpen: true
  //     })
  //     map.addControl(overviewControl)
  //   }

  //   var map
  //   initMap()
  // },

  methods: {
    // 获取顶部大图
    async getBannerList(showTo) {
      const { data: res } = await this.$request.post(
        `/SX_Company/GetBannerList?SxType=${this.$route.query.id}&ShowTo=${showTo}`
      )
      this.bannerList = res.data
    },

    initMap() {
      this.createMap()
      this.setMapEvent()
      this.addMapControl()
      this.addMapOverlay()
    },

    createMap() {
      // eslint-disable-next-line no-undef
      this.map = new BMap.Map('map')
      // eslint-disable-next-line no-undef
      // this.map.centerAndZoom(new BMap.Point(113.687568, 34.755562), 17)
      this.map.centerAndZoom(
        // eslint-disable-next-line no-undef
        new BMap.Point(this.footerInfo.LocationX, this.footerInfo.LocationY),
        17
      )
    },

    setMapEvent() {
      this.map.enableScrollWheelZoom()
      this.map.enableKeyboard()
      this.map.enableDragging()
      this.map.enableDoubleClickZoom()
    },

    addClickHandler(target, window) {
      target.addEventListener('click', function() {
        target.openInfoWindow(window)
      })
    },

    addMapOverlay() {
      var markers = [
        {
          content: `${
            this.footerInfo.MapProvince ? this.footerInfo.MapProvince : ''
          }${this.footerInfo.MapCity ? this.footerInfo.MapCity : ''}${
            this.footerInfo.MapDistrict ? this.footerInfo.MapDistrict : ''
          }${this.footerInfo.MapTownship ? this.footerInfo.MapTownship : ''}${
            this.footerInfo.MapStreet ? this.footerInfo.MapStreet : ''
          }${this.footerInfo.MapAddress ? this.footerInfo.MapAddress : ''}`,
          title: this.footerInfo.CompanyName,
          imageOffset: { width: 0, height: 3 },
          position: {
            lat: this.footerInfo.LocationY,
            lng: this.footerInfo.LocationX
          }
        }
      ]
      for (var index = 0; index < markers.length; index++) {
        // eslint-disable-next-line no-undef
        var point = new BMap.Point(
          markers[index].position.lng,
          markers[index].position.lat
        )
        // eslint-disable-next-line no-undef
        var marker = new BMap.Marker(point, {
          // eslint-disable-next-line no-undef
          icon: new BMap.Icon(
            'http://api.map.baidu.com/lbsapi/createmap/images/icon.png',
            // eslint-disable-next-line no-undef
            new BMap.Size(20, 25),
            {
              // eslint-disable-next-line no-undef
              imageOffset: new BMap.Size(
                markers[index].imageOffset.width,
                markers[index].imageOffset.height
              )
            }
          )
        })
        // eslint-disable-next-line no-undef
        var label = new BMap.Label(markers[index].title, {
          // eslint-disable-next-line no-undef
          offset: new BMap.Size(25, 5)
        })
        var opts = {
          width: 200,
          title: markers[index].title,
          enableMessage: false
        }
        // eslint-disable-next-line no-undef
        var infoWindow = new BMap.InfoWindow(markers[index].content, opts)
        marker.setLabel(label)
        this.addClickHandler(marker, infoWindow)
        this.map.addOverlay(marker)
      }
    },

    addMapControl() {
      // eslint-disable-next-line no-undef
      var scaleControl = new BMap.ScaleControl({
        // eslint-disable-next-line no-undef
        anchor: BMAP_ANCHOR_BOTTOM_LEFT
      })
      // eslint-disable-next-line no-undef
      scaleControl.setUnit(BMAP_UNIT_IMPERIAL)
      this.map.addControl(scaleControl)
      // eslint-disable-next-line no-undef
      var overviewControl = new BMap.OverviewMapControl({
        // eslint-disable-next-line no-undef
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        isOpen: true
      })
      this.map.addControl(overviewControl)
    },

    async getFooterInfo() {
      const { data: res } = await this.$request.post(
        '/SX_Company/GetSX_CompanyList'
      )
      this.footerInfo = res.data
      this.initMap()
    }
  }
}
</script>

<style lang="less" scoped>
// 面包屑
.crumbs_wrap {
  display: flex;
  align-items: center;
  font-size: 14px;
  height: 30px !important;
  color: #666;

  .iconfont {
    color: #c41a26;
    font-size: 20px;
    padding-right: 10px;
  }
}

// 关于我们
.brand_wrap {
  .show_wrap {
    padding-top: 60px;
    display: flex;
    justify-content: space-between;

    .map {
      width: 580px;
      height: 883px;
      border: #fff solid 1px;
      font-size: 12px;
    }

    .relation_wrap {
      width: 590px;

      .phone_box {
        h2 {
          color: #333;
          font-size: 30px;
          margin: 0;
        }

        .phone_ui {
          padding: 28px 0;
          margin: 0;

          .phone_item {
            display: flex;
            align-items: center;
            padding: 17px 0;
            border-bottom: 1px solid #ccc;

            .iconfont {
              font-size: 24px;
              color: #c04f52;
            }

            .title {
              padding-left: 15px;
              font-size: 20px;
              color: #666;
              span:nth-child(1) {
                padding-right: 110px;
              }
            }

            .title1 {
              display: flex;
              align-items: start;
              div:nth-child(1) {
                padding-right: 0;
                width: 245px;
              }
            }
          }
        }

        .phone_ui1 {
          padding: 26px 0 40px;
          .phone_item1 {
            padding: 0 0 15px;
            .title2 {
              line-height: 40px;
              padding-left: 0;
            }
          }
        }
      }

      .wx_box {
        h2 {
          color: #333;
          font-size: 30px;
          margin: 0;
        }

        .code_box {
          margin-top: 29px;
          width: 190px;
          height: 220px;
          background-color: #f5f5f5;
          padding-top: 12px;

          img {
            display: block;
            margin: auto;
            width: 167px;
            height: 167px;
          }

          div {
            padding-top: 12px;
            text-align: center;
            font-size: 16px;
            color: #666;
            .iconfont {
              padding-right: 8px;
              font-size: 18px;
            }
          }
        }
      }
    }
  }
}

// 通用
.dynamic_wrap {
  padding: 70px 0;

  .dynamic_title {
    text-transform: uppercase;
    text-align: center;
    div:nth-child(1) {
      padding-bottom: 17px;
      font-size: 30px;
      color: #b92e32;
    }

    div:nth-child(2) {
      align-items: center;
      font-size: 16px;
      color: #999;
    }
  }
}

// 关于我们切换
.enter_active {
  width: 88px;
  text-align: center;
  height: 36px;
  line-height: 36px;
  color: #feeb09 !important;
  background-color: #b92e32;
  padding: 0 !important;
  margin: 0 20px;
  border-radius: 100px;
}

// bootstrap
.breadcrumb {
  padding: 0;
  margin: 0;
  border-radius: 0;
  background-color: transparent;
}

// pc版心
.type_area {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

@media screen and (max-width: 480px) {
  .type_area {
    width: 375px;
  }

  .iconfont {
    padding: 0 10px;
  }

  .brand_wrap {
    .dynamic_wrap {
      padding: 30px 0;
      .show_wrap {
        padding-top: 30px;
        display: block;

        .map {
          width: 375px;
          height: 383px;

          .BMap_omOutFrame {
            width: 75px;
            height: 75px;
          }
        }

        .relation_wrap {
          width: 100vw;

          .phone_box {
            padding: 20px 0;
            h2 {
              font-size: 24px;
              padding-left: 20px;
            }
          }

          .phone_ui {
            padding: 0;
            margin: 0;

            .phone_item {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 17px 0;
              border-bottom: 1px solid #ccc;

              .iconfont {
                padding-left: 0;
                font-size: 20px;
                color: #c04f52;
              }

              .title {
                padding-left: 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 18px;
                color: #666;
                width: 270px;
                span:nth-child(1) {
                  padding-right: 0;
                }
              }

              .title1 {
                display: flex;
                align-items: start;
                div:nth-child(1) {
                  padding-right: 0;
                  width: 450px;
                }
              }
            }
          }

          .phone_ui1 {
            padding: 26px 0 40px;
            .phone_item1 {
              padding: 0 0 15px;
              display: block;
              .title2 {
                width: 100vw;
                display: block;
                line-height: 40px;
                padding: 0 10px;
              }
            }
          }

          .wx_box {
            h2 {
              font-size: 24px;
              text-align: center;
            }

            .code_box {
              margin: auto;
              margin-top: 29px;
              width: 190px;
              height: 220px;
              background-color: #f5f5f5;
              padding-top: 12px;
            }
          }
        }
      }
    }
  }

  .enter_active {
    width: 88px;
    margin: 0;
  }
}

@media screen and (max-width: 767px) and (min-width: 480px) {
  .type_area {
    width: 640px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .type_area {
    width: 768px;
  }
}

/* 1024-1200px */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .type_area {
    width: 970px;
  }
}

/* 大于1200 px */
@media screen and (min-width: 1200px) {
  .type_area {
    width: 1200px;
  }
}
</style>
